import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SubscriptionStatus } from '../pages/subscription/models/subscription-usage.model';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {

  constructor() {
    this.cleanseLocalStorage();
  }

  private cleanseLocalStorage(): void {
    try {
      const stored = localStorage.getItem('currentUser');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && (parsed.stripe_customer_id !== undefined || parsed.email !== undefined)) {
          const { stripe_customer_id, email, ...sanitized } = parsed;
          localStorage.setItem('currentUser', JSON.stringify(sanitized));
        }
      }
    } catch (e) {
      console.warn('Error cleansing localStorage currentUser', e);
    }
  }

  private getInitialUser(): any {
    try {
      const stored = localStorage.getItem('currentUser');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed) {
          const { stripe_customer_id, email, ...sanitized } = parsed;
          return sanitized;
        }
      }
    } catch (e) {}
    return null;
  }

  private user = new BehaviorSubject<any>(this.getInitialUser());
  private planUsage = new BehaviorSubject<SubscriptionStatus | null>(sessionStorage.getItem('planUsage') ? JSON.parse(sessionStorage.getItem('planUsage')) : null)
  private pendingInvitationsSubject = new BehaviorSubject<number>(0);
  pendingInvitations$ = this.pendingInvitationsSubject.asObservable();
  planUsageData: Observable<SubscriptionStatus | null> = this.planUsage.asObservable()
  currentUser: Observable<any> = this.user.asObservable()

  private _count$ = new BehaviorSubject<number>(0); // default 0
  count$ = this._count$.asObservable();

  private _refreshDowngrade$ = new BehaviorSubject<boolean>(false);
  refreshDowngrade = this._refreshDowngrade$.asObservable();

  updatePendingInvitations(count: number): void {
    this.pendingInvitationsSubject.next(count);
  }

  setCount(count: number) {
    this._count$.next(count);
  }

  setRefreshDowngrade(value: boolean) {
    this._refreshDowngrade$.next(value);
  }

  setUserData(values: any) {
    if (values) {
      const { stripe_customer_id, email, ...sanitized } = values;
      this.user.next(sanitized);
    } else {
      this.user.next(null);
    }
  }

  setPlanUsageData(usage: SubscriptionStatus | null) {
    this.planUsage.next(usage)
  }

}
